<template>
  <div>
    <p>
      <b-btn v-b-modal.createCatalogue>Create Catalogue</b-btn>
    </p>
    <b-modal
      id="createCatalogue"
      title="Create Catalogue"
      @ok="createCatalogue"
    >
      <b-input
        placeholder="Description"
        v-model="catalogue.description"
      ></b-input>
    </b-modal>
    <b-table striped hover :fields="fields" :items="catalogues">
      <template slot="actions" slot-scope="cell">
        <b-button-group>
          <b-button
            size="sm"
            class="align-top"
            variant="outline-secondary"
            :to="{ name: 'EditCatalogue', params: { id: cell.item.id } }"
          >
            <icon name="edit" class="align-middle"></icon>
          </b-button>
          <click-confirm>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click.stop="deleteCatalogue(cell.item)"
            >
              <icon name="remove" class="align-middle"></icon>
            </b-button>
          </click-confirm>
        </b-button-group>
      </template>
    </b-table>
  </div>
</template>

<script>
import Notify from "@/notify";
import PrintersApi from "@/printers_api";
import ClickConfirm from "click-confirm";

export default {
  components: {
    "click-confirm": ClickConfirm,
  },
  mixins: [Notify],
  data() {
    return {
      fields: ["description", "actions"],
      catalogues: [],
      catalogue: {
        description: "",
      },
    };
  },
  async created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      try {
        const response = await new PrintersApi(
          this.$auth.getAccessToken()
        ).listCatalogues();
        this.catalogues = response.data;
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async createCatalogue() {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).createCatalogue(
          this.catalogue
        );
        this.refresh();
        this.catalogue = { description: "" };
      } catch (e) {
        this.notifyError(e);
      }
    },
    async deleteCatalogue(item) {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).deleteCatalogue(
          item.id
        );
        this.refresh();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/printers/CatalogueTable.vue